import type {Task} from './types.js';

export const TASKS: Task[] = [
    {
        id: '1',
        name: 'Задача 1 из 5 от MasterBot',
        description: ['Изучите код и исправьте ошибки, \nкоторые принёс Chaos Monster', 'Добавьте деплойменту реплик \nи проверьте стратегию обновления \n(при обновлении тоже не должны \nвозникать даунтаймы)'],
        situation: ['Chaos Monster обрушился на кластер\n— реплики уничтожены. Ваш сервис\nдержится на одном хрупком поде.', 'Один сбой — и весь трафик рухнет\nв бездну даунтайма.\nВам предстоит переписать деплоймент\nтак, чтобы сервис выдерживал падения\nподов.'],
        hint: ['Укажи в манифесте .spec.replicas не меньше двух, \nи поправьте strategy.type, чтобы поды \nпересоздавались плавно.'],
        masterBotAdvice: [`Держите достаточно реплик — это \nгарантия доступности.`, `В Yandex Managed Service for \nKubernetes управляйте \nмасштабированием через интерфейс: \nукажите число реплик, а кластер сам \nдобавит узлы и обеспечит \nнадёжность.`],
        reward: 'Щит из реплик',
        rewardIcon: 'shield',
        brokenManifest: `apiVersion: apps/v1
kind: Deployment
metadata:
  name: frontend-app
spec:
  replicas: 1
  strategy:
    type: Recreate
  selector:
    matchLabels:
      app: frontend
  template:
    metadata:
      labels:
        app: frontend
    spec:
      containers:
      - name: frontend
        image: frontend-app:v1.0`,
        validationRules: [
            {
                path: 'spec.replicas',
                operator: 'greaterThan',
                expectedValue: 1,
                description: 'Deployment должен иметь минимум 2 реплики'
            },
            {
                path: 'spec.strategy.type',
                operator: 'in',
                expectedValue: ['RollingUpdate', undefined],
                description: 'Strategy должен быть RollingUpdate или отсутствовать'
            }
        ]
    },
    {
        id: '2',
        name: 'Задача 2 из 5 от MasterBot',
        description: ['Изучите код и исправьте ошибки, \nкоторые принёс Chaos Monster, \nподключив секрет в контейнер', 'Прокиньте имя пользователя \nи пароль к базе данных из секрета \nв переменные окружения \nприложения', 'Переменные должны называться \nDB_USER и DB_PASS',
            // 'Имена переменных окружения должны \nсоответствовать именам ключей в секрете'
        ],
        situation: ['Chaos Monster проник в сердце \nсервиса — и стёр его тайные ключи.\nПеременные окружения пусты. Пароли \nисчезли. Доступ к базе — потерян.', 'Сервис бьётся в агонии, не в силах \nвспомнить, кто он и куда идёт.\nВам предстоит вернуть контроль, \nподключив Secrets к поду.'],
        hint: ['Добавь в контейнер блок с envFrom \n(или переменную окружения с \nvalueFrom.secretKeyRef), ссылаясь на \nнужный секрет.'],
        masterBotAdvice: [`Храните чувствительные данные только в секретах, а не в явном виде! \nВ Yandex Managed Service for \nKubernetes секреты шифруются \nс помощью ключа KMS, а интеграция \nс Yandex Lockbox усиливает \nбезопасность.`],
        reward: 'Великая печать секретов',
        rewardIcon: 'print',
        brokenManifest: `apiVersion: apps/v1
kind: Deployment
metadata:
  name: backend-app
spec:
  replicas: 2
  selector:
    matchLabels:
      app: backend
  template:
    metadata:
      labels:
        app: backend
    spec:
      containers:
      - name: backend
        image: backend-app:v1.0
---
apiVersion: v1
kind: Secret
metadata:
  name: db-credentials
type: Opaque
data:
  DB_USER: dXNlcg==
  DB_PASS: cGFzcw==`,
        validationRules: [
            {
                path: 'spec.template.spec.containers[0].envFrom',
                operator: 'exists',
                description: 'Контейнер должен иметь envFrom с ссылкой на секрет db-credentials или env с valueFrom.secretKeyRef'
            }
        ]
    },
    {
        id: '3',
        name: 'Задача 3 из 5 от MasterBot',
        description: ['Добавьте пробу готовности \n(readinessProbe) и livenessProbe \nдля контейнера', 'Выберите простой httpGet \nна /healthz port: 8080', 'Путь проверки должен быть /healthz \nи порт 8080'],
        situation: ['Chaos Monster внедрился в цикл жизни \nпода — и остановил его сердцебиение.', 'Под поднят... но мёртв. \nНет livenessProbe. Нет readinessProbe.', 'Восстановите баланс, чтобы \nKubernetes снова понимал, когда ваш \nпод готов или сломался!'],
        hint: ['Добавь readinessProbe и livenessProbe, \nчтобы Kubernetes знал, когда контейнер \nготов принимать трафик и когда его \nперезапускать.'],
        masterBotAdvice: [`Настройте проверки доступности \nдля каждого пода — это поможет \nKubernetes быстро выявлять \nи устранять сбои. В Yandex Managed \nService for Kubernetes интеграция \nс Yandex Network Load Balancer \nупрощает управление сетевой \nдоступностью.`],
        reward: 'Взгляд Оракула',
        rewardIcon: 'vision',
        brokenManifest: `apiVersion: apps/v1
kind: Deployment
metadata:
  name: healthcheck-app
spec:
  replicas: 1
  selector:
    matchLabels:
      app: healthcheck
  template:
    metadata:
      labels:
        app: healthcheck
    spec:
      containers:
      - name: healthcheck
        image: backend-app:v1.0`,
        validationRules: [
            {
                path: 'spec.template.spec.containers[0].livenessProbe',
                operator: 'exists',
                description: 'Контейнер должен иметь livenessProbe'
            },
            {
                path: 'spec.template.spec.containers[0].livenessProbe.httpGet.path',
                operator: 'equals',
                expectedValue: '/healthz',
                description: 'livenessProbe должен проверять /healthz'
            },
            {
                path: 'spec.template.spec.containers[0].livenessProbe.httpGet.port',
                operator: 'equals',
                expectedValue: 8080,
                description: 'livenessProbe должен использовать порт 8080'
            },
            {
                path: 'spec.template.spec.containers[0].readinessProbe',
                operator: 'exists',
                description: 'Контейнер должен иметь readinessProbe'
            },
            {
                path: 'spec.template.spec.containers[0].readinessProbe.httpGet.path',
                operator: 'equals',
                expectedValue: '/healthz',
                description: 'readinessProbe должен проверять /healthz'
            },
            {
                path: 'spec.template.spec.containers[0].readinessProbe.httpGet.port',
                operator: 'equals',
                expectedValue: 8080,
                description: 'readinessProbe должен использовать порт 8080'
            }
        ]
    },
    {
        id: '4',
        name: 'Задача 4 из 5 от MasterBot',
        description: ['Удалите опасные права.', 'Отключите privileged, сбросьте \ncapabilities.', 'Верните контейнеру лишь то, \nчто ему действительно нужно'],
        situation: ['Chaos Monster распахнул врата \nкластера — и наделил контейнер \nбожественной властью.', 'Привилегированный контейнер — \nядро системы дрожит. Одна \nуязвимость в приложении — \nи злоумышленник получит доступ \nко всему узлу.', 'Сделайте так, чтобы даже сам \nChaos Monster не мог проникнуть \nсквозь ваши границы.'],
        hint: ['Поду не нужны доступы ко всем ресурсам \nноды, hostPID/hostNetwork/hostIPC \nопасны! Запусти приложение без \nлишних привилегий — выключи \nprivileged-режим и эскалацию, сбрось \nвсе capabilities, убери root.'],
        masterBotAdvice: [`Минимизируйте права контейнеров: \nне запускайте от root, удаляйте \nлишние capabilities, избегайте \nпривилегированного режима.`, `В Yandex Managed Service for \nKubernetes безопасность в \nприоритете — используйте KSPM для \nмониторинга и усиления защиты \nкластеров.`],
        reward: 'Страж границ',
        rewardIcon: 'guard',
        brokenManifest: `apiVersion: v1
kind: Pod
metadata:
  name: chaos-hacker
spec:
  hostPID: true
  hostIPC: true
  containers:
  - name: hacker
    image: app:vulnerable
    securityContext:
      privileged: true
      allowPrivilegeEscalation: true
      capabilities:
        add: ["SYS_ADMIN"]
      runAsUser: 0
  hostNetwork: true`,
        validationRules: [
            {
                path: 'spec.hostPID',
                operator: 'in',
                expectedValue: [false, undefined],
                description: 'hostPID должен быть false или отсутствовать'
            },
            {
                path: 'spec.hostIPC',
                operator: 'in',
                expectedValue: [false, undefined],
                description: 'hostIPC должен быть false или отсутствовать'
            },
            {
                path: 'spec.hostNetwork',
                operator: 'in',
                expectedValue: [false, undefined],
                description: 'hostNetwork должен быть false или отсутствовать'
            },
            {
                path: 'spec.containers[0].securityContext.privileged',
                operator: 'in',
                expectedValue: [false, undefined],
                description: 'privileged должен быть false или отсутствовать'
            },
            {
                path: 'spec.containers[0].securityContext.allowPrivilegeEscalation',
                operator: 'in',
                expectedValue: [false, undefined],
                description: 'allowPrivilegeEscalation должен быть false или отсутствовать'
            },
            {
                path: 'spec.containers[0].securityContext.runAsUser',
                operator: 'in',
                expectedValue: [1000, undefined],
                description: 'runAsUser должен быть !=0 или отсутствовать'
            }
        ]
    },
    {
        id: '5',
        name: 'Задача 5 из 5 от MasterBot',
        description: ['Наведите порядок, чтобы поды \nвсегда запускались на разных нодах.'],
        situation: ['Chaos Monster учинил беспорядок, \nи все поды, как стадо овец, скучились \nна одной слабой ноде. Один сбой — \nи весь сервис рухнет в пропасть \nпростоя.', 'Разделите поды. Настройте \npodAntiAffinity. Заставьте приложение \nуважать отказоустойчивость. Пусть \nкаждый под займёт свою ноду.'],
        hint: ['Не давай подам селиться кучей на одной \nноде! Через podAntiAffinity разбросай \nих по разным хостам (topologyKey=hostname), \nа лишние tolerations убери — пусть \nсервис живёт долго и надёжно.'],
        masterBotAdvice: [`Распределяйте реплики по разным \nнодам с помощью Affinity и \nAntiAffinity, чтобы избежать простоев. \nВ Yandex Managed Service for \nKubernetes поддерживается \nраспределение рабочих узлов \bкластера по трём независимым зонам доступности.`],
        reward: 'Хранитель равновесия',
        rewardIcon: 'storage',
        brokenManifest: `apiVersion: apps/v1
kind: Deployment
metadata:
  name: app
spec:
  replicas: 3
  selector:
    matchLabels:
      app: app
  template:
    metadata:
      labels:
        app: app
    spec:
      tolerations:
        - key: "chaosOnly"
          operator: "Exists"
      affinity:
        nodeAffinity:
          requiredDuringSchedulingIgnoredDuringExecution:
            nodeSelectorTerms:
              - matchExpressions:
                  - key: "kubernetes.io/hostname"
                    operator: In
                    values:
                      - evil-node-01
      containers:
      - name: app
        image: app:v1.0`,
        validationRules: [
            {
                path: 'spec.template.spec.tolerations',
                operator: 'notExists',
                description: 'tolerations с chaosOnly должны быть удалены'
            },
            {
                path: 'spec.template.spec.affinity.podAntiAffinity',
                operator: 'exists',
                description: 'Должен быть настроен podAntiAffinity'
            },
            {
                path: 'spec.template.spec.affinity.podAntiAffinity.requiredDuringSchedulingIgnoredDuringExecution[0].topologyKey',
                operator: 'equals',
                expectedValue: 'kubernetes.io/hostname',
                description: 'topologyKey должен быть kubernetes.io/hostname'
            }
        ]
    }
];

export function getTaskById(id: string): Task | undefined {
    return TASKS.find(task => task.id === id);
}

export function getAllTasks(): Task[] {
    return TASKS;
}
